import {useEffect} from 'react';
import * as amplitude from '@amplitude/analytics-browser';
import {sessionReplayPlugin} from '@amplitude/plugin-session-replay-browser';

import {getFullName, useAuthStore} from 'core/stores/auth';
import {useFeatureFlag, useUserInfo} from 'core/hooks/authHooks';
import {APP_VERSION} from 'core/constants/globalVariables';
import {impersonationToken} from 'core/impersonation';
import {FeatureFlags} from 'core/constants/featureFlags';
import {IS_PROD_ENV} from 'config';

const DEV_API_KEY = 'c0eb6e43a3e613d9cff03f1e59d50891';
const PROD_API_KEY = '277ced65bf08de8ee1312ebfe4ed1542';

export const useInitializeAmplitude = () => {
  const fullName = useAuthStore(getFullName);
  const {id, profile: {email} = {}, roles, roleType, permissions, tenantId, tenantName} = useUserInfo();
  const withAmplitude = useFeatureFlag(FeatureFlags.Amplitude);

  useEffect(() => {
    if (!withAmplitude || !email) {
      return;
    }

    amplitude.add(sessionReplayPlugin());

    const identify = new amplitude.Identify();
    identify
      .set('name', fullName)
      .set('tenantId', tenantId)
      .set('tenantName', tenantName)
      .set('isInternal', email.endsWith('@ennabl.com'))
      .set('impersonated', Boolean(impersonationToken))
      .set('roles', roles)
      .set('roleType', roleType)
      .set('permissions', permissions);

    amplitude.init(IS_PROD_ENV ? PROD_API_KEY : DEV_API_KEY, email, {
      appVersion: APP_VERSION,
      autocapture: {
        networkTracking: true,
        elementInteractions: {
          dataAttributePrefix: 'data-track',
        },
      },
    });
    amplitude.identify(identify);
  }, [id, roles, tenantId, tenantName, email, fullName, roleType, permissions, withAmplitude]);
};
